import axios from "axios";

//const baseURL = 'https://localhost:44342/api/'; //local
 const baseURL = 'https://qa.pharmacy.api.sehhasolutions.com/api/'; //prod

const apiServices = axios.create({
    baseURL,
});

// Add request interceptor to include token if available
apiServices.interceptors.request.use(
    (config) => {
        const token = sessionStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor for error handling
apiServices.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('user');
            window.location.href = '/admin-login';
        }
        return Promise.reject(error);
    }
);

export const GetLogin = async (Data) => {
    try {
        const response = await apiServices.post('Auth/Login', {
            Email: Data.Email,
            Password: Data.Password
        });
        return response.data;
    } catch (error) {
        console.error("Login error:", error);
        // Extract error message from response
        const errorMessage = error.response?.data?.message || 
                           error.response?.data?.Message || 
                           error.message || 
                           "Login failed. Please check your credentials.";
        throw new Error(errorMessage);
    }
}